import AboutComplex from './AboutComplex.vue';

export { AboutComplex };
export default AboutComplex;
